import { apiSlice } from "../../apiSlice";

const headers = { Modulecima: "dashboax" };

export const entregauApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getEntregauData: builder.query({
      query: (params) => ({
        url: `/Dashboax/Graphics/Entregau`,
        method: "GET",
        headers,
        params,
      }),
    }),
    getEntregauDetail: builder.query({
      query: (params) => ({
        url: `/Dashboax/Graphics/Entregau/detail`,
        method: "GET",
        headers,
        params,
      }),
    }),
    getEntregauGerencias: builder.query({
      query: () => ({
        url: `/Dashboax/Graphics/Entregau/gerencias`,
        method: "GET",
        headers,
      }),
    }),
    getEntregauGrupos: builder.query({
      query: (params) => ({
        url: `/Dashboax/Graphics/Entregau/grupos`,
        method: "GET",
        headers,
        params,
      }),
    }),
  }),
});

export const {
  useLazyGetEntregauDataQuery,
  useLazyGetEntregauDetailQuery,
  useGetEntregauGerenciasQuery,
  useLazyGetEntregauGruposQuery,
} = entregauApiSlice;
